<template>
  <div class="grid grid-cols-1 overflow-hidden rounded-lg md:grid-cols-2">
    <div
      class="bg-action-default-hi mood-main order-2 flex flex-col justify-center gap-24 p-32 md:order-none md:p-40"
    >
      <IconBattery class="text-[hsl(70,88%,73%)]" size="24" />
      <p class="text-static-light-hi heading-3">
        {{ i18n(title) }}
      </p>
      <RevLink
        class="!text-static-light-hi body-1 self-start"
        :underlined="true"
        @click="onOpen"
      >
        {{ i18n(translations.cta) }}
      </RevLink>
    </div>
    <RevIllustration
      :alt="i18n(translations.imageAlt)"
      class="order-1 h-full w-full object-cover md:order-none"
      :height="534"
      :src
      :width="800"
    />

    <BatteryStandardsDrawer :illustration-src="src" :name="DRAWER_NAME" />
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue'

import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { useTracking } from '@backmarket/nuxt-module-tracking/useTracking'
import { RevIllustration } from '@ds/components/Illustration'
import { RevLink } from '@ds/components/Link'
import { openModal } from '@ds/components/ModalBase'
import { IconBattery } from '@ds/icons/IconBattery'

import type { BatteryVariant } from '../../../../composables/useBatteryBlock/useBatteryBlock'

import translations from './BatteryBlock.translations'
import BatteryStandardsDrawer from './BatteryStandardsDrawer.vue'

const DRAWER_NAME = 'plp_battery_standards'
const TRACKING_ZONE = 'plp_battery_block'

const props = defineProps<{
  variant: BatteryVariant
  src: string
}>()

const i18n = useI18n()
const { trackClick } = useTracking()

const title = computed(() =>
  props.variant === 'laptops'
    ? translations.titleMacbook
    : translations.titleSmartphone,
)

function onOpen() {
  trackClick({ zone: TRACKING_ZONE, name: 'see_battery_standards' })
  openModal(DRAWER_NAME)
}
</script>
